import { BaseRestService } from './base-rest-service';

export interface IAuthTokenService {
    readonly authHeader?: AuthHeader;
    updateCsrfToken: () => Promise<string>;
}

class AuthHeader {
    'x-csrf-token': string;
    'oauth-token': string;
}

export const OAUTH_TOKEN_KEY = '';

export class AuthTokenService
    extends BaseRestService
    implements IAuthTokenService
{
    private get token() {
        const token = localStorage.getItem("csrfToken")
        return token ? token : '';
    }
    private get oAuthToken() {
        const token = localStorage.getItem("oAuthToken")
        return token ? token : '';
    }

    private set token(value: string) {
        if (value) {
            localStorage.setItem("csrfToken", value);
        }
    }

    public get authHeader() {
        let authHeader = new AuthHeader();
        if (this.token) {
            authHeader["x-csrf-token"] = this.token;
        }
        if (this.oAuthToken) {
            authHeader["oauth-token"] = this.oAuthToken;
        }

        if (!this.token && !this.oAuthToken) {
            return undefined;
        }

        return authHeader;
    }

    updateCsrfToken = async (): Promise<string> => {
        const { token } = await this.get<{ token: string }>({
            url: 'csrf/token',
        });
        this.token = token;
        return token;
    };
}
